// ORDERS ROUTES
export const TRANSPORT_ORDERS_ROUTE = "transport-orders";

export const SETTING_DEFINITIONS_CATEGORIES = [
  "Shipping & Fulfillment",
  "Product Configuration",
  "Documents & Templates",
  "Display / UI",
  "Scheduling & Cut-offs",
  "Billing",
  "Inbound Operations",
  "Notifications & Reporting",
  "Labels",
  "Inventory Tracking",
  "Shopify",
  "Reports"
];